<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <ng-container *ngIf="!isSummary; else summary">
            <div class="card">
              <div class="text-center">
                <h2><strong>Payment Information</strong></h2>
              </div>

              <ng-container *ngIf="payments.length > 0">
                <div class="row">
                  <div
                    class="col-6"
                    *ngFor="let item of payments"
                    style="cursor: pointer"
                  >
                    <span class="card-container">
                      <i
                        [ngClass]="
                          item.selected
                            ? 'fas fa-check-circle icon selected'
                            : 'fas fa-circle icon'
                        "
                      ></i>
                      <div
                        [ngClass]="
                          'credit-card-display ' + item.cardType.toLowerCase()
                        "
                        (click)="updatePaymentForm(item)"
                      >
                        <div class="card-pattern"></div>
                        <div class="card-content">
                          <img
                            [src]="
                              '../../../assets/img/resources/logos/' +
                              item.cardType +
                              '.png'
                            "
                            class="card-type-img"
                            [alt]="item.cardType"
                          />
                          <!-- <div class="card-chip"></div> -->
                          <img
                            src="/assets/img/chip.png"
                            alt=""
                            class="card-chip"
                          />
                          <div class="card-type-text">
                            {{ item.paymentType }}
                          </div>
                          <div class="card-number-display">
                            {{ item.accountCardNo | accountNumberMask }}
                          </div>
                          <div class="card-label">Expires</div>
                          <div class="card-expiry-display">
                            {{ item.expireDate | date : "MM/YYYY" }}
                          </div>
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4 ml-2">
                    <h6>Use Previous Payments</h6>
                  </div>
                </div>
                <br />
              </ng-container>
              <hr />
              <!-- Card form is only needed for non-PL countries; Poland uses hosted PayU page -->
              <form [formGroup]="form" novalidate *ngIf="invoice.BillingCountry !== 'PL'">
                <!-- <div class="form-group row" *ngIf="this.invoice['BillingCountry'] === 'CA'">
                <div class="col-4">
                  <label for="country" class="form-label">Payment Type <span class="text-danger">*</span></label>
                  <select formControlName="PaymentTypeCode">
                    <option value="">Select Payment Type</option>
                    <option value="DC">Debit Card</option>
                    <option value="CC">Credit Card</option>
                  </select>
                  <div *ngIf="
                        formControl.PaymentTypeCode.invalid &&
                        (formControl.PaymentTypeCode.dirty ||
                          formControl.PaymentTypeCode.touched ||
                          isSubmitted)
                      ">
                    <span class="text-danger" *ngIf="formControl.PaymentTypeCode.errors?.required">Payment Type is
                      required.</span>
                  </div>
                </div>

              </div> -->
                <div class="form-group row">
                  <div class="col-6">
                    <label for="country" class="form-label"
                      >Card Type <span class="text-danger">*</span></label
                    >
                    <select formControlName="CardType">
                      <option value="">Select Card Type</option>
                      <option
                        *ngFor="let item of cardTypes"
                        [value]="item.CardTypeCode"
                      >
                        {{ item.CardType }}
                      </option>
                    </select>
                    <div
                      *ngIf="
                        formControl.CardType.invalid &&
                        (formControl.CardType.dirty ||
                          formControl.CardType.touched ||
                          isSubmitted)
                      "
                    >
                      <span
                        class="text-danger"
                        *ngIf="formControl.CardType.errors?.required"
                        >Card Type is required.</span
                      >
                    </div>
                  </div>

                  <div class="col-6">
                    <label for="cvv" class="form-label">Cvv </label>
                    <input
                      type="text"
                      id="cvv"
                      formControlName="AccountCardCvv"
                    />
                  </div>

                  <div class="col-12">
                    <label class="form-label"
                      >Card Number <span class="text-danger">*</span></label
                    >
                    <input type="text" formControlName="AccountCardNo" />
                    <div
                      *ngIf="
                        formControl.AccountCardNo.invalid &&
                        (formControl.AccountCardNo.dirty ||
                          formControl.AccountCardNo.touched ||
                          isSubmitted)
                      "
                    >
                      <span
                        class="text-danger"
                        *ngIf="formControl.AccountCardNo.errors?.required"
                        >Account Number is required.</span
                      >
                      <span
                        class="text-danger"
                        *ngIf="formControl.AccountCardNo.errors?.pattern"
                        >Account Number is invalid.</span
                      >
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-6">
                    <label class="form-label"
                      >Expired Date <span class="text-danger">*</span></label
                    >
                    <input
                      type="month"
                      [min]="minDate"
                      formControlName="ExpireDate"
                    />
                    <div
                      *ngIf="
                        formControl.ExpireDate.invalid &&
                        (formControl.ExpireDate.dirty ||
                          formControl.ExpireDate.touched ||
                          isSubmitted)
                      "
                    >
                      <span
                        class="text-danger"
                        *ngIf="formControl.ExpireDate.errors?.required"
                        >Expire Date is required.</span
                      >
                    </div>
                  </div>
                  <div class="col-6">
                    <label class="form-label"
                      >Billing Address <span class="text-danger">*</span></label
                    >
                    <input type="text" formControlName="BillingAddress" />
                    <div
                      *ngIf="
                        formControl.BillingAddress.invalid &&
                        (formControl.BillingAddress.dirty ||
                          formControl.BillingAddress.touched ||
                          isSubmitted)
                      "
                    >
                      <span
                        class="text-danger"
                        *ngIf="formControl.BillingAddress.errors?.required"
                        >Billing Address is required.</span
                      >
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4">
                    <label class="form-label"
                      >State/Province <span class="text-danger">*</span></label
                    >
                    <input type="text" formControlName="BillingState" />

                    <!-- <ng-select formControlName="BillingState">
                    <ng-option value="" disabled>Select Billing State</ng-option>
                    <ng-option *ngFor="let option of states" [value]="option.StateProvCode">
                      {{option.StateProvName}}
                    </ng-option>
                  </ng-select> -->

                    <!-- <select formControlName="BillingState">
                    <option value="">Select Billing State</option>
                    <option *ngFor="let item of states" [value]="item.StateProvCode">
                      {{ item.StateProvName }}
                    </option>
                  </select> -->
                    <div
                      *ngIf="
                        formControl.BillingState.invalid &&
                        (formControl.BillingState.dirty ||
                          formControl.BillingState.touched ||
                          isSubmitted)
                      "
                    >
                      <span
                        class="text-danger"
                        *ngIf="formControl.BillingState.errors?.required"
                        >Billing State is required.</span
                      >
                    </div>
                  </div>
                  <div class="col-4">
                    <label for="city" class="form-label"
                      >City <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      id="city-input"
                      formControlName="BillingCity"
                      autocomplete="disabled"
                    />
                    <div
                      *ngIf="
                        formControl.BillingCity.invalid &&
                        (formControl.BillingCity.dirty ||
                          formControl.BillingCity.touched ||
                          isSubmitted)
                      "
                    >
                      <span
                        class="text-danger"
                        *ngIf="formControl.BillingCity.errors?.required"
                        >Billing City is required.</span
                      >
                    </div>
                  </div>
                  <div class="col-4">
                    <label for="postalCode" class="form-label"
                      >Zip Code <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="postalCode"
                      formControlName="PostalCode"
                    />
                    <div
                      *ngIf="
                        formControl.PostalCode.invalid &&
                        (formControl.PostalCode.dirty ||
                          formControl.PostalCode.touched ||
                          isSubmitted)
                      "
                    >
                      <span
                        class="text-danger"
                        *ngIf="formControl.PostalCode.errors?.required"
                        >Postal Code is required.</span
                      >
                    </div>
                  </div>
                </div>
              </form>

              <div class="d-grid gap-2" #!summary>
                <div class="row">
                  <div class="col-12 col-auto text-center">
                    <button
                      type="button"
                      (click)="backToHome()"
                      class="btn btn-outline-secondary"
                    >
                      Back</button
                    >&nbsp;
                    <button
                      type="submit"
                      class="btn btn-success"
                      (click)="onSubmit()"
                    >
                      {{ "Continue" }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-template #summary>
            <div class="summary-container">
              <!-- Header Card -->
              <div class="summary-card">
                <div class="summary-header">
                  <h4>Box Pickup Scheduled</h4>
                  <div class="invoice-number">
                    Invoice: {{ invoice.InvoiceNo }}
                  </div>
                </div>
              </div>

              <!-- Info Card -->
              <div class="summary-card">
                <div class="info-section">
                  <div class="info-row">
                    <div class="info-label">
                      <i class="fas fa-map-marker-alt"></i>
                      Source Branch
                    </div>
                    <div class="info-value">{{ branchName }}</div>
                  </div>
                  <div class="info-row">
                    <div class="info-label">
                      <i class="fas fa-route"></i>
                      Delivery Zone
                    </div>
                    <div class="info-value">
                      {{ this.invoice.DeliveryZoneCode }} - {{ deliveryZone }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Items Table -->
              <div
                class="summary-card"
                *ngIf="invoice && invoice.invoiceItemDetailList?.length"
              >
                <div class="items-table">
                  <table class="table table-responsive mb-0">
                    <thead>
                      <tr>
                        <th>Box Size</th>
                        <th>Dimension</th>
                        <th class="text-end">Item Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of invoice?.invoiceItemDetailList">
                        <td>{{ item.boxSizeDescription }}</td>
                        <td>{{ item.dimension }}</td>
                        <td class="text-end">
                          {{ item.unitPrice | number : "1.2-2" }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Notice Box -->
              <div class="notice-box">
                <p>
                  <i class="fas fa-info-circle"></i>
                  <span
                    >Please complete payment and wait for customer service to
                    contact you with pickup details.</span
                  >
                </p>
              </div>

              <!-- Payment Section -->
              <div class="payment-section">
                <h3 class="section-title">Payment Details</h3>

                <!-- Payment Method (not shown for PL since PayU hosted page collects card data) -->
                <div class="payment-method" *ngIf="invoice.BillingCountry !== 'PL'">
                  <div class="payment-method-left">
                    <div class="card-icon">
                      <!-- <i class="fa-brands fa-cc-visa"></i> -->
                    </div>
                    <div class="payment-details">
                      <div class="payment-type">
                        {{
                          this.formControl.PaymentTypeCode.value === "DB "
                            ? "Debit Card"
                            : "Credit Card"
                        }}
                      </div>
                      <div class="card-number">
                        {{
                          this.formControl.AccountCardNo.value
                            | accountNumberMask
                        }}<br />
                      </div>
                      <div class="card-expiry">
                        {{
                          this.formControl.ExpireDate.value | date : "MM/YYYY"
                        }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- PL-specific note -->
                <div class="notice-box" *ngIf="invoice.BillingCountry === 'PL'">
                  <p>
                    <i class="fas fa-credit-card"></i>
                    <span>You will be redirected to PayU's secure hosted payment page to enter your card details.</span>
                  </p>
                </div>

                <!-- Amount Breakdown -->
                <div class="amount-row">
                  <div class="amount-label">Transaction Amount</div>
                  <div class="amount-value">
                    <input
                      type="text"
                      value="{{ currency[invoice.BillingCountry] }} {{
                        invoice.TotalAmount | number : '1.2-2'
                      }}"
                      disabled
                    />
                  </div>
                </div>

                <div class="amount-row" *ngIf="(amountFormControl.PreviousPaymentTotal.value || 0) > 0">
                  <div class="amount-label">Previous Payment</div>
                  <div class="amount-value">
                    <input
                      type="text"
                      value="{{ currency[invoice.BillingCountry] }} {{
                        amountFormControl.PreviousPaymentTotal.value | number : '1.2-2'
                      }}"
                      disabled
                    />
                  </div>
                </div>

                <div class="amount-row">
                  <div class="amount-label">Tip Amount</div>
                  <div class="amount-value">
                    <a class="tip-link" (click)="addTip = true" *ngIf="!addTip">
                      <i class="fa fa-plus-circle"></i> Add Tip
                    </a>
                    <ng-container *ngIf="addTip">
                      <div [formGroup]="amountForm">
                        <input
                          type="number"
                          placeholder="0.00"
                          formControlName="TipAmount"
                          class="form-control"
                          numbersOnly
                        />
                      </div>
                      <div
                        *ngIf="
                          amountFormControl.TipAmount.invalid &&
                          (amountFormControl.TipAmount.dirty ||
                            amountFormControl.TipAmount.touched ||
                            isSubmitted)
                        "
                      >
                        <span
                          class="text-danger"
                          *ngIf="amountFormControl.TipAmount.errors?.min"
                          >Minimum is 0</span
                        >
                        <span
                          class="text-danger"
                          *ngIf="amountFormControl.TipAmount.errors?.max"
                          >Maximum is 20</span
                        >
                      </div>
                    </ng-container>
                  </div>
                </div>

                <div class="amount-row">
                  <div class="amount-label">
                    {{
                      invoice.BillingCountry == "CA"
                        ? "Surcharge"
                        : "Processing Fee"
                    }}
                  </div>
                  <div class="amount-value">
                    <input
                      value="{{ currency[invoice.BillingCountry] }} {{
                        amountFormControl.MerchantFee.value | number : '1.2-2'
                      }}"
                      disabled
                    />
                  </div>
                </div>

                <div class="total-row">
                  <div class="amount-row">
                    <div class="amount-label">Total Payable Amount</div>
                    <div class="amount-value">
                      <input
                        value="{{ currency[invoice.BillingCountry] }} {{
                          amountFormControl.PaymentAmount.value
                            | number : '1.2-2'
                        }}"
                        disabled
                      />
                    </div>
                  </div>
                </div>

                <!-- Error Example -->
                <!-- <div class="error-message">
                    <i class="fas fa-exclamation-circle"></i>
                    Payment Amount is required
                </div> -->
              </div>
            </div>

            <div class="payu-redirect-note notice-box" *ngIf="invoice.BillingCountry === 'PL'">
              <p>
                <i class="fas fa-lock"></i>
                <span>Click Pay Now to be securely redirected to PayU's payment page to complete your transaction.</span>
              </p>
            </div>

            <div class="controls d-grid gap-2">
              <div class="row">
                <div class="col-12 col-auto text-center">
                  <button
                    type="button"
                    (click)="backToHome()"
                    class="btn btn-outline-secondary"
                  >
                    Back</button
                  >&nbsp;
                  <button
                    type="submit"
                    class="btn btn-success"
                    (click)="onSubmit()"
                  >
                    {{ "Pay Now" }}
                  </button>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
        <ng-container *ngIf="!isSummary">
          <div class="col-md-6">
            <img src="/assets/img/boxes/rendered-box-1v2.png" alt="" />
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
